/**
 * token of signature
 */
export enum SignatureTokenEnum {
  /**
   * The signature token including QR-Code, Watermark, and Sign Details
   * @deprecated
   */
  SIGNATURE_TOKEN = "{{signature}}",

  /**
   * The signature token including QR-Code, Watermark, and Sign Details.
   */
  SIGNATURE_QR_TOKEN = "{{sign.qr}}",

  /**
   * Just the signature token just image
   */
  SIGNATURE_IMAGE_TOKEN = "{{sign.img}}",

  FREE_TEXT_TOKEN = "value",

  /**
   * Cross token to tick stuff
   */
  CROSS_TOKEN = "X"
}
